import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@zillow/constellation";
import { triggerTabClickEvent, CustomPropTypes } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const HtmlToReact = require("html-to-react");
const HtmlToReactParser = require("html-to-react").Parser;
const htmlToReactParser = new HtmlToReactParser();
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
const processingInstructions = [{
  shouldProcessNode() {
    return true;
  },
  processNode: processNodeDefinitions.processDefaultNode
}];
const TabsBlock = ({
  attrs,
  index,
  innerBlocks
}) => {
  const tabs = [];
  const panels = [];
  innerBlocks.forEach((innerBlock) => {
    const {
      tabId
    } = innerBlock.attrs;
    tabs.push(/* @__PURE__ */ jsx(Tabs.Tab, { id: tabId, children: htmlToReactParser.parseWithInstructions(innerBlock.attrs.label, () => true, processingInstructions) }, tabId));
    panels.push(/* @__PURE__ */ jsx(Tabs.Panel, { "aria-labelledby": tabId, id: innerBlock.attrs.id, children: generateBlockList({
      blocks: innerBlock.innerBlocks
    }) }, tabId));
  });
  const [selectedTabId, setSelectedTabId] = useState(
    // Start with defaultSelected tab otherwise the first tab. There will always be a first
    // tab because if the user removes the last tab in the editor, it removes the parent
    // "tabs" block.
    attrs.defaultSelectedId || innerBlocks[0].attrs.tabId
  );
  return /* @__PURE__ */ jsxs(Tabs, { appearance: attrs.appearance, selected: selectedTabId, onSelected: (tabId) => {
    setSelectedTabId(tabId);
    const tabInnerBlock = innerBlocks.find((innerBlock) => innerBlock.attrs.tabId === tabId);
    if (!tabInnerBlock) {
      throw new Error(`Could not find tab for tabId of "${tabId}"`);
    }
    triggerTabClickEvent({
      id: tabInnerBlock.attrs.id,
      label: tabInnerBlock.attrs.label
    });
  }, id: attrs.id, children: [
    /* @__PURE__ */ jsx(Tabs.List, { fluid: remapFluidTokensForConstellationV8(attrs.fluid), justifyContent: attrs.justifyContent, children: tabs }),
    /* @__PURE__ */ jsx(Tabs.Panels, { children: panels })
  ] }, index);
};
TabsBlock.propTypes = {
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    attrs: PropTypes.shape({
      tabId: PropTypes.string.isRequired,
      label: PropTypes.string
    })
  })),
  attrs: PropTypes.shape({
    appearance: PropTypes.string.isRequired,
    defaultSelectedId: PropTypes.string,
    fluid: PropTypes.shape({
      default: PropTypes.bool,
      lg_lte: PropTypes.bool,
      sm_lte: PropTypes.bool
    }).isRequired,
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(["center", "flex-start", "flex-end"]))
  }),
  index: PropTypes.number
};
function remapFluidTokensForConstellationV8(fluidValue) {
  if (typeof fluidValue !== "object" || fluidValue === null) {
    return fluidValue;
  }
  const remapped = {};
  if ("sm_lte" in fluidValue) {
    remapped.sm_lte = !!fluidValue.sm_lte;
  }
  if ("lg_lte" in fluidValue) {
    remapped.md_gte = !!fluidValue.lg_lte;
  }
  if ("default" in fluidValue) {
    remapped.xl_gte = !!fluidValue.default;
  }
  return remapped;
}
export {
  TabsBlock as default,
  remapFluidTokensForConstellationV8
};
